import * as React from 'react'

import { Alert, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

const OrdinanceAlert = () => {
  return (
    <Alert color="note">
      <Text.Normal color="grey1000" weight="normal">
        {i18n.t('clock_in.modals.export.ordinance.description')} &nbsp;
        <a
          href="https://help.factorialhr.com/pt-br/obtenha-todos-os-documentos-exigidos-pela-nova-portaria-671"
          style={{ fontWeight: '500', color: '#1C242B', textDecoration: 'underline' }}
          target="_blank"
          rel="nofollow noopener noreferrer"
        >
          {i18n.t('clock_in.modals.export.ordinance.learn')}
        </a>
      </Text.Normal>
    </Alert>
  )
}

export default OrdinanceAlert
